import gql from 'graphql-tag'
import client from '@stores/apollo'
import { BuildingTypeFragment } from '@api/fragments'

export default function create(id: string) {
  return client.gql.mutate({ mutation, variables: { input: { id } } })
}

const mutation = gql`
  mutation deleteBuildingType($input: DeleteBuildingTypeInput!) {
    deleteBuildingType(input: $input) {
      buildingType {
        ...BuildingTypeFragment
      }
    }
  }
  ${BuildingTypeFragment}
`
